import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import classnames from "classnames";

import { Icon } from "@sportal/cdk";
import { addProfile } from "../../../store/profiles";
import { Button } from "../../button/Button";
import { AddProfileModal } from "../../profileModals/addProfileModal/AddProfileModal";
import { ModalService } from "../../modal";
import { useIntlTranslate } from "../../../hooks";

import "./NewProfileCard.scss";

export const NewProfileCard = ({ availableProfilesNumber, className }) => {
  const dispatch = useDispatch();
  const translate = useIntlTranslate();

  return (
    <li
      className={classnames("new-profile-card", className)}
      aria-label={translate("aria_create_new_group_card")}
    >
      <div className="new-profile-card__content">
        <p>
          <FormattedMessage id="create_profiles_first" />
        </p>
        <p className="strong">
          <FormattedMessage
            id="create_profiles_second"
            values={{ availableProfilesNumber }}
          />
        </p>
        <Button
          size="large"
          color="primary"
          variant="outlined"
          className="new-profile-card__button"
          onClick={() => {
            ModalService.show((modal) => ({
              dialog: <AddProfileModal modal={modal} />,
            }))
              .then((profile) => dispatch(addProfile(profile)))
              .catch(() => {});
          }}
          iconLeft={<Icon icon="fa-solid fa-plus" />}
        >
          <span className="new-profile-card__button__text">
            <FormattedMessage id="add_new_profile" />
          </span>
        </Button>
      </div>
    </li>
  );
};

NewProfileCard.propTypes = {
  availableProfilesNumber: PropTypes.number.isRequired,
  className: PropTypes.string,
};
